import k, { useState as lt, useCallback as ft } from "react";
import { r as dt, m as D, Y as se, F as N, J as pt, o as ie, a as vt } from "./index4.js";
import { a as Ye, h as q, p as bt, K as ht, D as Oe, T as yt, O as mt, Q as gt, V as Ot, z as I } from "./index2.js";
import { a as Ze, g as Je, c as Tt } from "./jsx-runtime.js";
import { b as wt, d as Dt, V as Et } from "./index8.js";
import { c as le } from "./polished.esm.js";
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Qe = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], ee = /* @__PURE__ */ Qe.join(","), et = typeof Element > "u", M = et ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, fe = !et && Element.prototype.getRootNode ? function(r) {
  return r.getRootNode();
} : function(r) {
  return r.ownerDocument;
}, tt = function(e, t, a) {
  var n = Array.prototype.slice.apply(e.querySelectorAll(ee));
  return t && M.call(e, ee) && n.unshift(e), n = n.filter(a), n;
}, nt = function r(e, t, a) {
  for (var n = [], i = Array.from(e); i.length; ) {
    var u = i.shift();
    if (u.tagName === "SLOT") {
      var s = u.assignedElements(), b = s.length ? s : u.children, d = r(b, !0, a);
      a.flatten ? n.push.apply(n, d) : n.push({
        scope: u,
        candidates: d
      });
    } else {
      var h = M.call(u, ee);
      h && a.filter(u) && (t || !e.includes(u)) && n.push(u);
      var g = u.shadowRoot || // check for an undisclosed shadow
      typeof a.getShadowRoot == "function" && a.getShadowRoot(u), F = !a.shadowRootFilter || a.shadowRootFilter(u);
      if (g && F) {
        var C = r(g === !0 ? u.children : g.children, !0, a);
        a.flatten ? n.push.apply(n, C) : n.push({
          scope: u,
          candidates: C
        });
      } else
        i.unshift.apply(i, u.children);
    }
  }
  return n;
}, rt = function(e, t) {
  return e.tabIndex < 0 && (t || /^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || e.isContentEditable) && isNaN(parseInt(e.getAttribute("tabindex"), 10)) ? 0 : e.tabIndex;
}, Ft = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, at = function(e) {
  return e.tagName === "INPUT";
}, kt = function(e) {
  return at(e) && e.type === "hidden";
}, St = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(a) {
    return a.tagName === "SUMMARY";
  });
  return t;
}, Ct = function(e, t) {
  for (var a = 0; a < e.length; a++)
    if (e[a].checked && e[a].form === t)
      return e[a];
}, Rt = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || fe(e), a = function(s) {
    return t.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, n;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    n = a(window.CSS.escape(e.name));
  else
    try {
      n = a(e.name);
    } catch (u) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", u.message), !1;
    }
  var i = Ct(n, e.form);
  return !i || i === e;
}, xt = function(e) {
  return at(e) && e.type === "radio";
}, Pt = function(e) {
  return xt(e) && !Rt(e);
}, Te = function(e) {
  var t = e.getBoundingClientRect(), a = t.width, n = t.height;
  return a === 0 && n === 0;
}, Nt = function(e, t) {
  var a = t.displayCheck, n = t.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var i = M.call(e, "details>summary:first-of-type"), u = i ? e.parentElement : e;
  if (M.call(u, "details:not([open]) *"))
    return !0;
  var s = fe(e).host, b = (s == null ? void 0 : s.ownerDocument.contains(s)) || e.ownerDocument.contains(e);
  if (!a || a === "full") {
    if (typeof n == "function") {
      for (var d = e; e; ) {
        var h = e.parentElement, g = fe(e);
        if (h && !h.shadowRoot && n(h) === !0)
          return Te(e);
        e.assignedSlot ? e = e.assignedSlot : !h && g !== e.ownerDocument ? e = g.host : e = h;
      }
      e = d;
    }
    if (b)
      return !e.getClientRects().length;
  } else if (a === "non-zero-area")
    return Te(e);
  return !1;
}, jt = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var a = 0; a < t.children.length; a++) {
          var n = t.children.item(a);
          if (n.tagName === "LEGEND")
            return M.call(t, "fieldset[disabled] *") ? !0 : !n.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, te = function(e, t) {
  return !(t.disabled || kt(t) || Nt(t, e) || // For a details element with a summary, the summary element gets the focus
  St(t) || jt(t));
}, de = function(e, t) {
  return !(Pt(t) || rt(t) < 0 || !te(e, t));
}, It = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, At = function r(e) {
  var t = [], a = [];
  return e.forEach(function(n, i) {
    var u = !!n.scope, s = u ? n.scope : n, b = rt(s, u), d = u ? r(n.candidates) : s;
    b === 0 ? u ? t.push.apply(t, d) : t.push(s) : a.push({
      documentOrder: i,
      tabIndex: b,
      item: n,
      isScope: u,
      content: d
    });
  }), a.sort(Ft).reduce(function(n, i) {
    return i.isScope ? n.push.apply(n, i.content) : n.push(i.content), n;
  }, []).concat(t);
}, it = function(e, t) {
  t = t || {};
  var a;
  return t.getShadowRoot ? a = nt([e], t.includeContainer, {
    filter: de.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: It
  }) : a = tt(e, t.includeContainer, de.bind(null, t)), At(a);
}, ot = function(e, t) {
  t = t || {};
  var a;
  return t.getShadowRoot ? a = nt([e], t.includeContainer, {
    filter: te.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : a = tt(e, t.includeContainer, te.bind(null, t)), a;
}, K = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return M.call(e, ee) === !1 ? !1 : de(t, e);
}, Lt = /* @__PURE__ */ Qe.concat("iframe").join(","), Q = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return M.call(e, Lt) === !1 ? !1 : te(t, e);
};
const $t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  focusable: ot,
  isFocusable: Q,
  isTabbable: K,
  tabbable: it
}, Symbol.toStringTag, { value: "Module" }));
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function we(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(r);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function De(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? we(Object(t), !0).forEach(function(a) {
      _t(r, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : we(Object(t)).forEach(function(a) {
      Object.defineProperty(r, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return r;
}
function _t(r, e, t) {
  return e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
var Ee = function() {
  var r = [];
  return {
    activateTrap: function(t) {
      if (r.length > 0) {
        var a = r[r.length - 1];
        a !== t && a.pause();
      }
      var n = r.indexOf(t);
      n === -1 || r.splice(n, 1), r.push(t);
    },
    deactivateTrap: function(t) {
      var a = r.indexOf(t);
      a !== -1 && r.splice(a, 1), r.length > 0 && r[r.length - 1].unpause();
    }
  };
}(), zt = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Mt = function(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}, Bt = function(e) {
  return e.key === "Tab" || e.keyCode === 9;
}, Fe = function(e) {
  return setTimeout(e, 0);
}, ke = function(e, t) {
  var a = -1;
  return e.every(function(n, i) {
    return t(n) ? (a = i, !1) : !0;
  }), a;
}, V = function(e) {
  for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    a[n - 1] = arguments[n];
  return typeof e == "function" ? e.apply(void 0, a) : e;
}, W = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, qt = function(e, t) {
  var a = (t == null ? void 0 : t.document) || document, n = De({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0
  }, t), i = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  }, u, s = function(o, c, p) {
    return o && o[c] !== void 0 ? o[c] : n[p || c];
  }, b = function(o) {
    return i.containerGroups.findIndex(function(c) {
      var p = c.container, m = c.tabbableNodes;
      return p.contains(o) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      m.find(function(O) {
        return O === o;
      });
    });
  }, d = function(o) {
    var c = n[o];
    if (typeof c == "function") {
      for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), O = 1; O < p; O++)
        m[O - 1] = arguments[O];
      c = c.apply(void 0, m);
    }
    if (c === !0 && (c = void 0), !c) {
      if (c === void 0 || c === !1)
        return c;
      throw new Error("`".concat(o, "` was specified but was not a node, or did not return a node"));
    }
    var T = c;
    if (typeof c == "string" && (T = a.querySelector(c), !T))
      throw new Error("`".concat(o, "` as selector refers to no known node"));
    return T;
  }, h = function() {
    var o = d("initialFocus");
    if (o === !1)
      return !1;
    if (o === void 0)
      if (b(a.activeElement) >= 0)
        o = a.activeElement;
      else {
        var c = i.tabbableGroups[0], p = c && c.firstTabbableNode;
        o = p || d("fallbackFocus");
      }
    if (!o)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return o;
  }, g = function() {
    if (i.containerGroups = i.containers.map(function(o) {
      var c = it(o, n.tabbableOptions), p = ot(o, n.tabbableOptions);
      return {
        container: o,
        tabbableNodes: c,
        focusableNodes: p,
        firstTabbableNode: c.length > 0 ? c[0] : null,
        lastTabbableNode: c.length > 0 ? c[c.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(O) {
          var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, w = p.findIndex(function(S) {
            return S === O;
          });
          if (!(w < 0))
            return T ? p.slice(w + 1).find(function(S) {
              return K(S, n.tabbableOptions);
            }) : p.slice(0, w).reverse().find(function(S) {
              return K(S, n.tabbableOptions);
            });
        }
      };
    }), i.tabbableGroups = i.containerGroups.filter(function(o) {
      return o.tabbableNodes.length > 0;
    }), i.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
  }, F = function f(o) {
    if (o !== !1 && o !== a.activeElement) {
      if (!o || !o.focus) {
        f(h());
        return;
      }
      o.focus({
        preventScroll: !!n.preventScroll
      }), i.mostRecentlyFocusedNode = o, zt(o) && o.select();
    }
  }, C = function(o) {
    var c = d("setReturnFocus", o);
    return c || (c === !1 ? !1 : o);
  }, P = function(o) {
    var c = W(o);
    if (!(b(c) >= 0)) {
      if (V(n.clickOutsideDeactivates, o)) {
        u.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: n.returnFocusOnDeactivate && !Q(c, n.tabbableOptions)
        });
        return;
      }
      V(n.allowOutsideClick, o) || o.preventDefault();
    }
  }, L = function(o) {
    var c = W(o), p = b(c) >= 0;
    p || c instanceof Document ? p && (i.mostRecentlyFocusedNode = c) : (o.stopImmediatePropagation(), F(i.mostRecentlyFocusedNode || h()));
  }, B = function(o) {
    var c = W(o);
    g();
    var p = null;
    if (i.tabbableGroups.length > 0) {
      var m = b(c), O = m >= 0 ? i.containerGroups[m] : void 0;
      if (m < 0)
        o.shiftKey ? p = i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : p = i.tabbableGroups[0].firstTabbableNode;
      else if (o.shiftKey) {
        var T = ke(i.tabbableGroups, function(z) {
          var G = z.firstTabbableNode;
          return c === G;
        });
        if (T < 0 && (O.container === c || Q(c, n.tabbableOptions) && !K(c, n.tabbableOptions) && !O.nextTabbableNode(c, !1)) && (T = m), T >= 0) {
          var w = T === 0 ? i.tabbableGroups.length - 1 : T - 1, S = i.tabbableGroups[w];
          p = S.lastTabbableNode;
        }
      } else {
        var R = ke(i.tabbableGroups, function(z) {
          var G = z.lastTabbableNode;
          return c === G;
        });
        if (R < 0 && (O.container === c || Q(c, n.tabbableOptions) && !K(c, n.tabbableOptions) && !O.nextTabbableNode(c)) && (R = m), R >= 0) {
          var U = R === i.tabbableGroups.length - 1 ? 0 : R + 1, _ = i.tabbableGroups[U];
          p = _.firstTabbableNode;
        }
      }
    } else
      p = d("fallbackFocus");
    p && (o.preventDefault(), F(p));
  }, $ = function(o) {
    if (Mt(o) && V(n.escapeDeactivates, o) !== !1) {
      o.preventDefault(), u.deactivate();
      return;
    }
    if (Bt(o)) {
      B(o);
      return;
    }
  }, j = function(o) {
    var c = W(o);
    b(c) >= 0 || V(n.clickOutsideDeactivates, o) || V(n.allowOutsideClick, o) || (o.preventDefault(), o.stopImmediatePropagation());
  }, l = function() {
    if (i.active)
      return Ee.activateTrap(u), i.delayInitialFocusTimer = n.delayInitialFocus ? Fe(function() {
        F(h());
      }) : F(h()), a.addEventListener("focusin", L, !0), a.addEventListener("mousedown", P, {
        capture: !0,
        passive: !1
      }), a.addEventListener("touchstart", P, {
        capture: !0,
        passive: !1
      }), a.addEventListener("click", j, {
        capture: !0,
        passive: !1
      }), a.addEventListener("keydown", $, {
        capture: !0,
        passive: !1
      }), u;
  }, y = function() {
    if (i.active)
      return a.removeEventListener("focusin", L, !0), a.removeEventListener("mousedown", P, !0), a.removeEventListener("touchstart", P, !0), a.removeEventListener("click", j, !0), a.removeEventListener("keydown", $, !0), u;
  };
  return u = {
    get active() {
      return i.active;
    },
    get paused() {
      return i.paused;
    },
    activate: function(o) {
      if (i.active)
        return this;
      var c = s(o, "onActivate"), p = s(o, "onPostActivate"), m = s(o, "checkCanFocusTrap");
      m || g(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = a.activeElement, c && c();
      var O = function() {
        m && g(), l(), p && p();
      };
      return m ? (m(i.containers.concat()).then(O, O), this) : (O(), this);
    },
    deactivate: function(o) {
      if (!i.active)
        return this;
      var c = De({
        onDeactivate: n.onDeactivate,
        onPostDeactivate: n.onPostDeactivate,
        checkCanReturnFocus: n.checkCanReturnFocus
      }, o);
      clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, y(), i.active = !1, i.paused = !1, Ee.deactivateTrap(u);
      var p = s(c, "onDeactivate"), m = s(c, "onPostDeactivate"), O = s(c, "checkCanReturnFocus"), T = s(c, "returnFocus", "returnFocusOnDeactivate");
      p && p();
      var w = function() {
        Fe(function() {
          T && F(C(i.nodeFocusedBeforeActivation)), m && m();
        });
      };
      return T && O ? (O(C(i.nodeFocusedBeforeActivation)).then(w, w), this) : (w(), this);
    },
    pause: function() {
      return i.paused || !i.active ? this : (i.paused = !0, y(), this);
    },
    unpause: function() {
      return !i.paused || !i.active ? this : (i.paused = !1, g(), l(), this);
    },
    updateContainerElements: function(o) {
      var c = [].concat(o).filter(Boolean);
      return i.containers = c.map(function(p) {
        return typeof p == "string" ? a.querySelector(p) : p;
      }), i.active && g(), this;
    }
  }, u.updateContainerElements(e), u;
};
const Ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: qt
}, Symbol.toStringTag, { value: "Module" })), Gt = /* @__PURE__ */ Ze(Ut), Vt = /* @__PURE__ */ Ze($t);
function pe(r) {
  "@babel/helpers - typeof";
  return pe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pe(r);
}
function Ht(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Se(r, e) {
  for (var t = 0; t < e.length; t++) {
    var a = e[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(r, a.key, a);
  }
}
function Kt(r, e, t) {
  return e && Se(r.prototype, e), t && Se(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function Xt(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), Object.defineProperty(r, "prototype", { writable: !1 }), e && ve(r, e);
}
function ve(r, e) {
  return ve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, n) {
    return a.__proto__ = n, a;
  }, ve(r, e);
}
function Wt(r) {
  var e = Zt();
  return function() {
    var a = ne(r), n;
    if (e) {
      var i = ne(this).constructor;
      n = Reflect.construct(a, arguments, i);
    } else
      n = a.apply(this, arguments);
    return Yt(this, n);
  };
}
function Yt(r, e) {
  if (e && (pe(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return X(r);
}
function X(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Zt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ne(r) {
  return ne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ne(r);
}
function Jt(r, e, t) {
  return e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
var Y = k, v = Ye, Qt = Gt, en = Qt.createFocusTrap, tn = Vt, nn = tn.isFocusable, be = /* @__PURE__ */ function(r) {
  Xt(t, r);
  var e = Wt(t);
  function t(a) {
    var n;
    Ht(this, t), n = e.call(this, a), Jt(X(n), "getNodeForOption", function(s) {
      var b, d = (b = this.internalOptions[s]) !== null && b !== void 0 ? b : this.originalOptions[s];
      if (typeof d == "function") {
        for (var h = arguments.length, g = new Array(h > 1 ? h - 1 : 0), F = 1; F < h; F++)
          g[F - 1] = arguments[F];
        d = d.apply(void 0, g);
      }
      if (d === !0 && (d = void 0), !d) {
        if (d === void 0 || d === !1)
          return d;
        throw new Error("`".concat(s, "` was specified but was not a node, or did not return a node"));
      }
      var C = d;
      if (typeof d == "string") {
        var P;
        if (C = (P = this.getDocument()) === null || P === void 0 ? void 0 : P.querySelector(d), !C)
          throw new Error("`".concat(s, "` as selector refers to no known node"));
      }
      return C;
    }), n.handleDeactivate = n.handleDeactivate.bind(X(n)), n.handlePostDeactivate = n.handlePostDeactivate.bind(X(n)), n.handleClickOutsideDeactivates = n.handleClickOutsideDeactivates.bind(X(n)), n.internalOptions = {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      returnFocusOnDeactivate: !1,
      // the rest of these are also related to deactivation of the trap, and we
      //  need to use them and control them as well
      checkCanReturnFocus: null,
      onDeactivate: n.handleDeactivate,
      onPostDeactivate: n.handlePostDeactivate,
      // we need to special-case this setting as well so that we can know if we should
      //  NOT return focus if the trap gets auto-deactivated as the result of an
      //  outside click (otherwise, we'll always think we should return focus because
      //  of how we manage that flag internally here)
      clickOutsideDeactivates: n.handleClickOutsideDeactivates
    }, n.originalOptions = {
      // because of the above `internalOptions`, we maintain our own flag for
      //  this option, and default it to `true` because that's focus-trap's default
      returnFocusOnDeactivate: !0,
      // because of the above `internalOptions`, we keep these separate since
      //  they're part of the deactivation process which we configure (internally) to
      //  be shared between focus-trap and focus-trap-react
      onDeactivate: null,
      onPostDeactivate: null,
      checkCanReturnFocus: null,
      // the user's setting, defaulted to false since focus-trap defaults this to false
      clickOutsideDeactivates: !1
    };
    var i = a.focusTrapOptions;
    for (var u in i)
      if (Object.prototype.hasOwnProperty.call(i, u)) {
        if (u === "returnFocusOnDeactivate" || u === "onDeactivate" || u === "onPostDeactivate" || u === "checkCanReturnFocus" || u === "clickOutsideDeactivates") {
          n.originalOptions[u] = i[u];
          continue;
        }
        n.internalOptions[u] = i[u];
      }
    return n.outsideClick = null, n.focusTrapElements = a.containerElements || [], n.updatePreviousElement(), n;
  }
  return Kt(t, [{
    key: "getDocument",
    value: function() {
      return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
    }
    /**
     * Gets the node for the given option, which is expected to be an option that
     *  can be either a DOM node, a string that is a selector to get a node, `false`
     *  (if a node is explicitly NOT given), or a function that returns any of these
     *  values.
     * @param {string} optionName
     * @returns {undefined | false | HTMLElement | SVGElement} Returns
     *  `undefined` if the option is not specified; `false` if the option
     *  resolved to `false` (node explicitly not given); otherwise, the resolved
     *  DOM node.
     * @throws {Error} If the option is set, not `false`, and is not, or does not
     *  resolve to a node.
     */
  }, {
    key: "getReturnFocusNode",
    value: function() {
      var n = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
      return n || (n === !1 ? !1 : this.previouslyFocusedElement);
    }
    /** Update the previously focused element with the currently focused element. */
  }, {
    key: "updatePreviousElement",
    value: function() {
      var n = this.getDocument();
      n && (this.previouslyFocusedElement = n.activeElement);
    }
  }, {
    key: "deactivateTrap",
    value: function() {
      !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
        // NOTE: we never let the trap return the focus since we do that ourselves
        returnFocus: !1,
        // we'll call this in our own post deactivate handler so make sure the trap doesn't
        //  do it prematurely
        checkCanReturnFocus: null,
        // let it call the user's original deactivate handler, if any, instead of
        //  our own which calls back into this function
        onDeactivate: this.originalOptions.onDeactivate
        // NOTE: for post deactivate, don't specify anything so that it calls the
        //  onPostDeactivate handler specified on `this.internalOptions`
        //  which will always be our own `handlePostDeactivate()` handler, which
        //  will finish things off by calling the user's provided onPostDeactivate
        //  handler, if any, at the right time
        // onPostDeactivate: NOTHING
      });
    }
  }, {
    key: "handleClickOutsideDeactivates",
    value: function(n) {
      var i = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, n) : this.originalOptions.clickOutsideDeactivates;
      return i && (this.outsideClick = {
        target: n.target,
        allowDeactivation: i
      }), i;
    }
  }, {
    key: "handleDeactivate",
    value: function() {
      this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
    }
  }, {
    key: "handlePostDeactivate",
    value: function() {
      var n = this, i = function() {
        var s = n.getReturnFocusNode(), b = !!// did the consumer allow it?
        (n.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
        s !== null && s !== void 0 && s.focus && // was there an outside click that allowed deactivation?
        (!n.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
        n.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
        //  as a result of the click-through) -- in which case do NOT restore focus
        //  to `returnFocusNode` because focus should remain on the outside node
        !nn(n.outsideClick.target, n.internalOptions.tabbableOptions))), d = n.internalOptions.preventScroll, h = d === void 0 ? !1 : d;
        b && s.focus({
          preventScroll: h
        }), n.originalOptions.onPostDeactivate && n.originalOptions.onPostDeactivate.call(null), n.outsideClick = null;
      };
      this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(i, i) : i();
    }
  }, {
    key: "setupFocusTrap",
    value: function() {
      if (this.focusTrap)
        this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      else {
        var n = this.focusTrapElements.some(Boolean);
        n && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      }
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.props.active && this.setupFocusTrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      if (this.focusTrap) {
        n.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
        var i = !n.active && this.props.active, u = n.active && !this.props.active, s = !n.paused && this.props.paused, b = n.paused && !this.props.paused;
        if (i && (this.updatePreviousElement(), this.focusTrap.activate()), u) {
          this.deactivateTrap();
          return;
        }
        s && this.focusTrap.pause(), b && this.focusTrap.unpause();
      } else
        n.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props.children ? Y.Children.only(this.props.children) : void 0;
      if (i) {
        if (i.type && i.type === Y.Fragment)
          throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
        var u = function(d) {
          var h = n.props.containerElements;
          i && (typeof i.ref == "function" ? i.ref(d) : i.ref && (i.ref.current = d)), n.focusTrapElements = h || [d];
        }, s = Y.cloneElement(i, {
          ref: u
        });
        return s;
      }
      return null;
    }
  }]), t;
}(Y.Component), H = typeof Element > "u" ? Function : Element;
be.propTypes = {
  active: v.bool,
  paused: v.bool,
  focusTrapOptions: v.shape({
    document: v.object,
    onActivate: v.func,
    onPostActivate: v.func,
    checkCanFocusTrap: v.func,
    onDeactivate: v.func,
    onPostDeactivate: v.func,
    checkCanReturnFocus: v.func,
    initialFocus: v.oneOfType([v.instanceOf(H), v.string, v.bool, v.func]),
    fallbackFocus: v.oneOfType([
      v.instanceOf(H),
      v.string,
      // NOTE: does not support `false` as value (or return value from function)
      v.func
    ]),
    escapeDeactivates: v.oneOfType([v.bool, v.func]),
    clickOutsideDeactivates: v.oneOfType([v.bool, v.func]),
    returnFocusOnDeactivate: v.bool,
    setReturnFocus: v.oneOfType([v.instanceOf(H), v.string, v.bool, v.func]),
    allowOutsideClick: v.oneOfType([v.bool, v.func]),
    preventScroll: v.bool,
    tabbableOptions: v.shape({
      displayCheck: v.oneOf(["full", "non-zero-area", "none"]),
      getShadowRoot: v.oneOfType([v.bool, v.func])
    })
  }),
  containerElements: v.arrayOf(v.instanceOf(H)),
  // DOM element ONLY
  children: v.oneOfType([
    v.element,
    // React element
    v.instanceOf(H)
    // DOM element
  ])
  // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.
};
be.defaultProps = {
  active: !0,
  paused: !1,
  focusTrapOptions: {},
  _createFocusTrap: en
};
var rn = be;
const an = /* @__PURE__ */ Je(rn);
var ct = { exports: {} };
(function(r, e) {
  (function(t, a) {
    r.exports = a(k, Ye, dt);
  })(Tt, function(t, a, n) {
    function i(l) {
      return l && typeof l == "object" && "default" in l ? l : { default: l };
    }
    function u(l) {
      if (l && typeof l == "object" && "default" in l)
        return l;
      var y = /* @__PURE__ */ Object.create(null);
      return l && Object.keys(l).forEach(function(f) {
        if (f !== "default") {
          var o = Object.getOwnPropertyDescriptor(l, f);
          Object.defineProperty(y, f, o.get ? o : { enumerable: !0, get: function() {
            return l[f];
          } });
        }
      }), y.default = l, Object.freeze(y);
    }
    var s = u(t), b = i(a);
    function d(l) {
      var y = function(f, o) {
        if (typeof f != "object" || !f)
          return f;
        var c = f[Symbol.toPrimitive];
        if (c !== void 0) {
          var p = c.call(f, o || "default");
          if (typeof p != "object")
            return p;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (o === "string" ? String : Number)(f);
      }(l, "string");
      return typeof y == "symbol" ? y : y + "";
    }
    function h(l, y, f) {
      return (y = d(y)) in l ? Object.defineProperty(l, y, { value: f, enumerable: !0, configurable: !0, writable: !0 }) : l[y] = f, l;
    }
    function g() {
      return g = Object.assign ? Object.assign.bind() : function(l) {
        for (var y = 1; y < arguments.length; y++) {
          var f = arguments[y];
          for (var o in f)
            Object.prototype.hasOwnProperty.call(f, o) && (l[o] = f[o]);
        }
        return l;
      }, g.apply(this, arguments);
    }
    function F(l, y) {
      if (l == null)
        return {};
      var f, o, c = function(m, O) {
        if (m == null)
          return {};
        var T, w, S = {}, R = Object.keys(m);
        for (w = 0; w < R.length; w++)
          T = R[w], O.indexOf(T) >= 0 || (S[T] = m[T]);
        return S;
      }(l, y);
      if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(l);
        for (o = 0; o < p.length; o++)
          f = p[o], y.indexOf(f) >= 0 || Object.prototype.propertyIsEnumerable.call(l, f) && (c[f] = l[f]);
      }
      return c;
    }
    function C(l, y) {
      return y || (y = l.slice(0)), Object.freeze(Object.defineProperties(l, { raw: { value: Object.freeze(y) } }));
    }
    var P, L, B = { small: 14, default: 16, large: 20, xlarge: 24 }, $ = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], j = function(l) {
      var y = l.className, f = l.size, o = f === void 0 ? 16 : f, c = l.title, p = l["aria-label"], m = l["aria-labelledby"], O = l.fill, T = l.role, w = T === void 0 ? "img" : T, S = F(l, $), R = n.css(P || (P = C([`
        color: `, `;
      `])), O), U = n.css(L || (L = C([`
        flex-shrink: 0;
      `]))), _ = function(z, G, ae) {
        var he, ye = ae["aria-label"], me = ae["aria-labelledby"], ge = ae.title;
        switch (z) {
          case "img":
            return ye || me || ge ? h(h(h({}, "aria-labelledby", me), "aria-label", ye), "title", ge) : { "aria-label": (he = G, "".concat(he.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }(w, "X", h(h({ title: c }, "aria-label", p), "aria-labelledby", m));
      return s.createElement("svg", g({ className: n.cx(h({}, R, O != null), U, y), height: typeof o == "number" ? o : B[o], width: typeof o == "number" ? o : B[o], role: w }, _, S, { viewBox: "0 0 16 16" }), s.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2028 3.40381C11.8123 3.01329 11.1791 3.01329 10.7886 3.40381L8.3137 5.87869L5.83883 3.40381C5.44831 3.01329 4.81514 3.01329 4.42462 3.40381L3.71751 4.11092C3.32699 4.50144 3.32699 5.13461 3.71751 5.52513L6.19238 8.00001L3.71751 10.4749C3.32699 10.8654 3.32699 11.4986 3.71751 11.8891L4.42462 12.5962C4.81514 12.9867 5.44831 12.9867 5.83883 12.5962L8.3137 10.1213L10.7886 12.5962C11.1791 12.9867 11.8123 12.9867 12.2028 12.5962L12.9099 11.8891C13.3004 11.4986 13.3004 10.8654 12.9099 10.4749L10.435 8.00001L12.9099 5.52513C13.3004 5.13461 13.3004 4.50144 12.9099 4.11092L12.2028 3.40381Z", fill: "currentColor" }));
    };
    return j.displayName = "X", j.isGlyph = !0, j.propTypes = { fill: b.default.string, size: b.default.oneOfType([b.default.number, b.default.string]), className: b.default.string }, j;
  });
})(ct);
var on = ct.exports;
const cn = /* @__PURE__ */ Je(on);
function x(r, e, t) {
  return (e = function(a) {
    var n = function(i, u) {
      if (typeof i != "object" || i === null)
        return i;
      var s = i[Symbol.toPrimitive];
      if (s !== void 0) {
        var b = s.call(i, u || "default");
        if (typeof b != "object")
          return b;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (u === "string" ? String : Number)(i);
    }(a, "string");
    return typeof n == "symbol" ? n : String(n);
  }(e)) in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function re() {
  return re = Object.assign ? Object.assign.bind() : function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }, re.apply(this, arguments);
}
function un(r, e) {
  if (r == null)
    return {};
  var t, a, n = function(u, s) {
    if (u == null)
      return {};
    var b, d, h = {}, g = Object.keys(u);
    for (d = 0; d < g.length; d++)
      b = g[d], s.indexOf(b) >= 0 || (h[b] = u[b]);
    return h;
  }(r, e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);
    for (a = 0; a < i.length; a++)
      t = i[a], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(r, t) && (n[t] = r[t]);
  }
  return n;
}
function E(r, e) {
  return e || (e = r.slice(0)), Object.freeze(Object.defineProperties(r, { raw: { value: Object.freeze(e) } }));
}
function sn(r, e) {
  return function(t) {
    if (Array.isArray(t))
      return t;
  }(r) || function(t, a) {
    var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (n != null) {
      var i, u, s, b, d = [], h = !0, g = !1;
      try {
        if (s = (n = n.call(t)).next, a === 0) {
          if (Object(n) !== n)
            return;
          h = !1;
        } else
          for (; !(h = (i = s.call(n)).done) && (d.push(i.value), d.length !== a); h = !0)
            ;
      } catch (F) {
        g = !0, u = F;
      } finally {
        try {
          if (!h && n.return != null && (b = n.return(), Object(b) !== b))
            return;
        } finally {
          if (g)
            throw u;
        }
      }
      return d;
    }
  }(r, e) || function(t, a) {
    if (t) {
      if (typeof t == "string")
        return Ce(t, a);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
        return Array.from(t);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return Ce(t, a);
    }
  }(r, e) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ce(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, a = new Array(e); t < e; t++)
    a[t] = r[t];
  return a;
}
var Re;
D(Re || (Re = E([`
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: right;
  flex-direction: row-reverse;
  padding: 24px 35px 35px;
`])));
var xe, Pe, Ne, oe, je, Ie, Ae, Le, $e, ce, _e, ze, Me, Be, qe, Ue, Ge, Ve, Z, He, Ke, Xe, J, ue, A = { Default: "default", Dark: "dark", Light: "light" }, ut = { Small: "small", Default: "default", Large: "large" }, ln = "".concat(vt.Desktop + 1, "px"), fn = D(xe || (xe = E([`
  overflow-y: auto;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity `, `ms ease-in-out;
`])), se.default), dn = (x(oe = {}, q.Light, D(Pe || (Pe = E([`
    background-color: `, `;
  `])), le(0.4, N.black))), x(oe, q.Dark, D(Ne || (Ne = E([`
    background-color: `, `;
  `])), le(0.4, N.gray.dark2))), oe), pn = D(je || (je = E([`
  opacity: 1;
`]))), vn = D(Ie || (Ie = E([`
  position: absolute;
  min-height: 100%;
  width: 100%;
  padding: `, "px ", `px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`])), 64, 18), bn = D(Ae || (Ae = E([`
  font-family: `, `;
  transition: transform `, `ms ease-in-out,
    opacity `, `ms ease-in-out;
  margin: auto;
  max-height: calc(100% - `, `px);
  position: relative;
  pointer-events: all;
  transform: translate3d(0, -16px, 0);
  opacity: 0;
  border-radius: 24px;
  padding: 40px 36px;
  box-shadow: 0px 8px 20px -8px `, `;

  &:focus {
    outline: none;
  }
`])), pt.default, se.default, se.default, 64, le(0.4, N.black)), hn = (x(ce = {}, q.Light, D(Le || (Le = E([`
    color: `, `;
    background-color: `, `;
  `])), N.black, N.white)), x(ce, q.Dark, D($e || ($e = E([`
    color: `, `;
    background-color: `, `;
  `])), N.gray.light2, N.black)), ce), yn = D(_e || (_e = E([`
  transform: translate3d(0, 0, 0);
  opacity: 1;
`]))), mn = { small: D(ze || (ze = E([`
    width: 400px;
  `]))), default: D(Me || (Me = E([`
    width: 600px;
  `]))), large: D(Be || (Be = E([`
    width: 720px;

    @media only screen and (min-width: `, `) {
      width: 960px;
    }
  `])), ln) }, gn = D(qe || (qe = E([`
  position: absolute;
  cursor: pointer;
  // x-icon should be 24px from edge. IconButton is 28x28 and Icon is 16x16
  // so there's already (28 - 16) / 2 = 6px of spacing. 24 - 6 = 18.
  right: 18px;
  top: 18px;
`]))), On = (x(ue = {}, q.Light, (x(Z = {}, A.Default, D(Ue || (Ue = E([`
      color: `, `;
    `])), N.gray.dark1)), x(Z, A.Dark, D(Ge || (Ge = E([`
      color: `, `;
    `])), N.black)), x(Z, A.Light, D(Ve || (Ve = E([`
      color: `, `;
    `])), N.gray.light2)), Z)), x(ue, q.Dark, (x(J = {}, A.Default, D(He || (He = E([`
      color: `, `;
    `])), N.gray.base)), x(J, A.Dark, D(Ke || (Ke = E([`
      color: `, `;
    `])), N.black)), x(J, A.Light, D(Xe || (Xe = E([`
      color: `, `;
    `])), N.gray.light2)), J)), ue), Tn = ["open", "size", "setOpen", "shouldClose", "closeIconColor", "darkMode", "id", "children", "className", "contentClassName", "initialFocus"], st = k.forwardRef(function(r, e) {
  var t = r.open, a = t !== void 0 && t, n = r.size, i = n === void 0 ? ut.Default : n, u = r.setOpen, s = u === void 0 ? function() {
  } : u, b = r.shouldClose, d = b === void 0 ? function() {
    return !0;
  } : b, h = r.closeIconColor, g = h === void 0 ? A.Default : h, F = r.darkMode, C = r.id, P = r.children, L = r.className, B = r.contentClassName, $ = r.initialFocus, j = un(r, Tn), l = bt(F), y = l.theme, f = l.darkMode, o = k.useRef(null), c = e ?? o, p = sn(lt(null), 2), m = p[0], O = p[1], T = ht().isPopoverOpen, w = ft(function() {
    s && d() && s(!1);
  }, [s, d]), S = Oe({ prefix: "modal", id: C }), R = Oe({ prefix: "modal" });
  yt(w, { enabled: a && !T });
  var U = $ ? { initialFocus: "#".concat(S, " ").concat($), fallbackFocus: "#".concat(R) } : { fallbackFocus: "#".concat(R) };
  return k.createElement(wt, { in: a, timeout: 150, mountOnEnter: !0, unmountOnExit: !0, nodeRef: o }, function(_) {
    return k.createElement(Dt, null, k.createElement("div", re({}, j, { id: S, ref: c, className: ie(L, fn, dn[y], x({}, pn, _ === "entered")) }), k.createElement(mt, { darkMode: f }, k.createElement(an, { active: _ === "entered", focusTrapOptions: U }, k.createElement("div", { className: vn, ref: function(z) {
      return O(z);
    } }, k.createElement("div", { "aria-modal": "true", role: "dialog", tabIndex: -1, className: ie(bn, hn[y], mn[i], x({}, yn, _ === "entered"), B) }, k.createElement(gt, { popover: { portalContainer: m, scrollContainer: m } }, P, k.createElement(Et, { id: R, onClick: w, "aria-label": "Close modal", className: ie(gn, On[y][g]) }, k.createElement(cn, null)))))))));
  });
});
st.displayName = "ModalView";
var We = k.forwardRef(function(r, e) {
  return k.createElement(Ot, null, k.createElement(st, re({}, r, { ref: e })));
});
We.displayName = "Modal", We.propTypes = { open: I.bool, size: I.oneOf(Object.values(ut)), children: I.node, shouldClose: I.func, className: I.string, setOpen: I.func, darkMode: I.bool, closeIconColor: I.oneOf(Object.values(A)) };
export {
  We as h
};
